import React from 'react';
import Modal from './common/Modal';

const formatDateTime = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return new Intl.DateTimeFormat('en-IN', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(date);
};
const AttachmentSection = ({ title, attachments }) => {
  const imageUrlPrefix = process.env.REACT_APP_IMAGES_URL || '';

  if (!attachments || attachments.length === 0) {
    return <p className="text-sm text-gray-500 dark:text-gray-400">No {title.toLowerCase()} uploaded.</p>;
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-2">
      {attachments.map((attachment) => (
        <a
          key={attachment.id}
          href={`${imageUrlPrefix}${attachment.photoUrl}`}
          target="_blank"
          rel="noreferrer"
          className="block border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden hover:shadow-lg transition-shadow"
        >
          <img
            src={`${imageUrlPrefix}${attachment.photoUrl}`}
            alt={`${title} ${attachment.id}`}
            className="w-full h-40 object-cover bg-gray-100 dark:bg-gray-900"
          />
          <div className="px-3 py-2 text-xs text-gray-600 dark:text-gray-300">
            <p className="font-medium capitalize">{attachment.photoType || title}</p>
            <p className="mt-1">Uploaded: {formatDateTime(attachment.uploadedAt)}</p>
          </div>
        </a>
      ))}
    </div>
  );
};


export default function OrderAttachmentModal({ order, onClose }) {
  if (!order) return null;

  const orderLevelAttachments = (order.pickupAttachments || []).filter((attachment) => !attachment.orderShopId);
  const shopAttachments = Array.isArray(order.shops) ? order.shops : [];

  return (
    <Modal onClose={onClose}>
      <div className="space-y-6">
        <div>
          <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100">Order Attachments</h2>
          {order.showId && (
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">Order ID: {order.showId}</p>
          )}
        </div>

        {orderLevelAttachments.length > 0 && (
          <div>
            <h3 className="text-sm font-semibold text-gray-700 dark:text-gray-200 uppercase tracking-wide">General Attachments</h3>
            <AttachmentSection title="Attachments" attachments={orderLevelAttachments} />
          </div>
        )}

        {shopAttachments.length > 0 ? (
          <div className="space-y-6">
            {shopAttachments.map((shop) => {
              const invoicePhotos = (shop.attachments || []).filter((attachment) => attachment.photoType === 'invoice');
              const packagePhotos = (shop.attachments || []).filter((attachment) => attachment.photoType === 'package');
              return (
                <div key={shop.id}>
                  <div className="flex items-center justify-between">
                    <h3 className="text-base font-semibold text-gray-700 dark:text-gray-200">
                      {shop.shop?.name || 'Shop'}
                    </h3>
                    {shop.deliveredAt && (
                      <span className="text-xs text-gray-500 dark:text-gray-400">
                        Delivered: {formatDateTime(shop.deliveredAt)}
                      </span>
                    )}
                  </div>
                  <div className="mt-3 space-y-4">
                    <div>
                      <h4 className="text-sm font-medium text-gray-600 dark:text-gray-300">Invoice Photos</h4>
                      <AttachmentSection title="Invoice" attachments={invoicePhotos} />
                    </div>
                    <div>
                      <h4 className="text-sm font-medium text-gray-600 dark:text-gray-300">Package Photos</h4>
                      <AttachmentSection title="Package" attachments={packagePhotos} />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <p className="text-sm text-gray-500 dark:text-gray-400">No shop attachments available.</p>
        )}
      </div>
    </Modal>
  );
}
